// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* contentMainPage.css */

:root {
  /* Content Page Colors — mapped to global root tokens where a match exists */

  /* #323539 → --typography-text-body-primary */
  --scl--cms-pages-content-title-color:                  var(--typography-text-body-primary);
  --scl--cms-pages-content-search-input-color:           var(--typography-text-body-primary);
  --scl--cms-pages-content-dropdown-item-color:          var(--typography-text-body-primary);

  /* #8A8B8F → --typography-text-body-secondary */
  --scl--cms-pages-content-description-color:            var(--typography-text-body-secondary);
  --scl--cms-pages-content-search-placeholder-color:     var(--typography-text-body-secondary);
  --scl--cms-pages-content-action-icon-color:            var(--typography-text-body-secondary);
  --scl--cms-pages-content-dropdown-item-icon-color:     var(--typography-text-body-secondary);

  /* #EFF3F8 → --action-hover */
  --scl--cms-pages-content-table-row-hover-bg:           var(--action-hover);
  --scl--cms-pages-content-table-row-selected-bg:        var(--action-hover);

  /* No matching global token — kept as raw rgba values */
  --scl--cms-pages-content-action-button-hover-bg:       rgba(138, 139, 143, 0.1);
  --scl--cms-pages-content-action-button-active-bg:      rgba(138, 139, 143, 0.2);
  --scl--cms-pages-content-dropdown-item-hover-bg:       rgba(138, 139, 143, 0.08);
  --scl--cms-pages-content-dropdown-trigger-hover-bg:    rgba(237, 238, 240, 0.5);
  --scl--cms-pages-content-dropdown-trigger-active-bg:   rgba(237, 238, 240, 0.8);
}

/* ========================================
   CONTENT PAGE CONTAINER
   ======================================== */

.scl--cms-pages-content {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  font-family: var(--scl--default-font);
}

/* ========================================
   PAGE HEADER
   ======================================== */

.scl--cms-pages-content-header {
  padding: 0;
  margin-bottom: 16px;
}

.scl--cms-pages-content-headerContainer {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.scl--cms-pages-content-title {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: var(--scl--cms-pages-content-title-color);
  margin: 0;
}

.scl--cms-pages-content-description {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.01em;
  color: var(--scl--cms-pages-content-description-color);
  margin: 0;
}

/* ========================================
   FILTERS SECTION
   ======================================== */

.scl--cms-pages-content-filters {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 16px;
}

.scl--cms-pages-content-filtersSelectField {
  position: relative;
  display: flex;
  align-items: center;
  width: 118px;
}

.scl--cms-pages-content-filtersSearch {
  position: relative;
  display: flex;
  align-items: center;
  width: 279px;
}

.scl--cms-pages-content-searchInput {
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  font-family: var(--scl--default-font);
  font-size: 16px;
  line-height: 22px;
  color: var(--scl--cms-pages-content-search-input-color);
  outline: none;
}

.scl--cms-pages-content-searchInput::placeholder {
  color: var(--scl--cms-pages-content-search-placeholder-color);
}

/* ========================================
   TABLE
   ======================================== */

.scl--cms-pages-content-tableWrapper {
  width: 100%;
  margin-bottom: 16px;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row .scl--components-table-dynamicTable-select-column {
  padding: 0;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-header-row .scl--components-table-dynamicTable-select-column {
  padding: 0;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-select-cell-content {
  padding: 0;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-cell:last-child,
.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-header-cell:last-child {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ========================================
   ACTION BUTTONS
   ======================================== */

.scl--cms-pages-content-actions {
  gap: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: fit-content;
  margin: 0 auto;
}

/* Action dropdown wrapper */
.scl--cms-pages-content-actionDropdown {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
}

.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-popup-item {
  padding: 10px 16px;
  font-size: 14px;
  font-family: var(--scl--default-font);
  font-weight: 400;
  color: var(--scl--cms-pages-content-dropdown-item-color);
  transition: background-color 0.15s ease;
}

.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-popup-item:hover {
  background: var(--scl--cms-pages-content-dropdown-item-hover-bg);
}

/* Override ActionButton styles for the dropdown trigger */
.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton:hover {
  background: var(--scl--cms-pages-content-dropdown-trigger-hover-bg);
}

.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton:active {
  background: var(--scl--cms-pages-content-dropdown-trigger-active-bg);
}

/* Make the wrapper align with icon action buttons */
.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
}

/* ========================================
   TABLE OVERRIDES
   ======================================== */

.scl--cms-pages-content-tableWrapper .scl--components-pagination-container {
  margin-top: 10px;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-main tbody td:last-child {
  align-items: center;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row.selected {
  background: var(--scl--cms-pages-content-table-row-selected-bg) !important;
}

.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row:hover {
  background: var(--scl--cms-pages-content-table-row-hover-bg) !important;
}

/* ========================================
   EMPTY STATE
   ======================================== */

.scl--cms-pages-content-emptyWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/main-content/css/contentMainPage.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,4EAA4E;;EAE5E,6CAA6C;EAC7C,0FAA0F;EAC1F,0FAA0F;EAC1F,0FAA0F;;EAE1F,+CAA+C;EAC/C,4FAA4F;EAC5F,4FAA4F;EAC5F,4FAA4F;EAC5F,4FAA4F;;EAE5F,6BAA6B;EAC7B,0EAA0E;EAC1E,0EAA0E;;EAE1E,uDAAuD;EACvD,+EAA+E;EAC/E,+EAA+E;EAC/E,gFAAgF;EAChF,+EAA+E;EAC/E,+EAA+E;AACjF;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;;6CAE6C;;AAE7C;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sDAAsD;EACtD,SAAS;AACX;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;6CAE6C;;AAE7C;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,wDAAwD;EACxD,uCAAuC;AACzC;;AAEA;EACE,gEAAgE;AAClE;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,oEAAoE;AACtE;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;6CAE6C;;AAE7C;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,uEAAuE;AACzE;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* contentMainPage.css */\n\n:root {\n  /* Content Page Colors — mapped to global root tokens where a match exists */\n\n  /* #323539 → --typography-text-body-primary */\n  --scl--cms-pages-content-title-color:                  var(--typography-text-body-primary);\n  --scl--cms-pages-content-search-input-color:           var(--typography-text-body-primary);\n  --scl--cms-pages-content-dropdown-item-color:          var(--typography-text-body-primary);\n\n  /* #8A8B8F → --typography-text-body-secondary */\n  --scl--cms-pages-content-description-color:            var(--typography-text-body-secondary);\n  --scl--cms-pages-content-search-placeholder-color:     var(--typography-text-body-secondary);\n  --scl--cms-pages-content-action-icon-color:            var(--typography-text-body-secondary);\n  --scl--cms-pages-content-dropdown-item-icon-color:     var(--typography-text-body-secondary);\n\n  /* #EFF3F8 → --action-hover */\n  --scl--cms-pages-content-table-row-hover-bg:           var(--action-hover);\n  --scl--cms-pages-content-table-row-selected-bg:        var(--action-hover);\n\n  /* No matching global token — kept as raw rgba values */\n  --scl--cms-pages-content-action-button-hover-bg:       rgba(138, 139, 143, 0.1);\n  --scl--cms-pages-content-action-button-active-bg:      rgba(138, 139, 143, 0.2);\n  --scl--cms-pages-content-dropdown-item-hover-bg:       rgba(138, 139, 143, 0.08);\n  --scl--cms-pages-content-dropdown-trigger-hover-bg:    rgba(237, 238, 240, 0.5);\n  --scl--cms-pages-content-dropdown-trigger-active-bg:   rgba(237, 238, 240, 0.8);\n}\n\n/* ========================================\n   CONTENT PAGE CONTAINER\n   ======================================== */\n\n.scl--cms-pages-content {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  font-family: var(--scl--default-font);\n}\n\n/* ========================================\n   PAGE HEADER\n   ======================================== */\n\n.scl--cms-pages-content-header {\n  padding: 0;\n  margin-bottom: 16px;\n}\n\n.scl--cms-pages-content-headerContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.scl--cms-pages-content-title {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 40px;\n  color: var(--scl--cms-pages-content-title-color);\n  margin: 0;\n}\n\n.scl--cms-pages-content-description {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  color: var(--scl--cms-pages-content-description-color);\n  margin: 0;\n}\n\n/* ========================================\n   FILTERS SECTION\n   ======================================== */\n\n.scl--cms-pages-content-filters {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 16px;\n}\n\n.scl--cms-pages-content-filtersSelectField {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 118px;\n}\n\n.scl--cms-pages-content-filtersSearch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 279px;\n}\n\n.scl--cms-pages-content-searchInput {\n  flex: 1;\n  height: 100%;\n  border: none;\n  background: transparent;\n  font-family: var(--scl--default-font);\n  font-size: 16px;\n  line-height: 22px;\n  color: var(--scl--cms-pages-content-search-input-color);\n  outline: none;\n}\n\n.scl--cms-pages-content-searchInput::placeholder {\n  color: var(--scl--cms-pages-content-search-placeholder-color);\n}\n\n/* ========================================\n   TABLE\n   ======================================== */\n\n.scl--cms-pages-content-tableWrapper {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row .scl--components-table-dynamicTable-select-column {\n  padding: 0;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-header-row .scl--components-table-dynamicTable-select-column {\n  padding: 0;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-select-cell-content {\n  padding: 0;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-cell:last-child,\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-header-cell:last-child {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ========================================\n   ACTION BUTTONS\n   ======================================== */\n\n.scl--cms-pages-content-actions {\n  gap: 5px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  width: fit-content;\n  margin: 0 auto;\n}\n\n/* Action dropdown wrapper */\n.scl--cms-pages-content-actionDropdown {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 25px;\n  height: 25px;\n}\n\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-popup-item {\n  padding: 10px 16px;\n  font-size: 14px;\n  font-family: var(--scl--default-font);\n  font-weight: 400;\n  color: var(--scl--cms-pages-content-dropdown-item-color);\n  transition: background-color 0.15s ease;\n}\n\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-popup-item:hover {\n  background: var(--scl--cms-pages-content-dropdown-item-hover-bg);\n}\n\n/* Override ActionButton styles for the dropdown trigger */\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton {\n  width: 25px;\n  height: 25px;\n  border-radius: 4px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton:hover {\n  background: var(--scl--cms-pages-content-dropdown-trigger-hover-bg);\n}\n\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton:active {\n  background: var(--scl--cms-pages-content-dropdown-trigger-active-bg);\n}\n\n/* Make the wrapper align with icon action buttons */\n.scl--cms-pages-content-actionDropdown .scl--cms-components-actionButton-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 25px;\n}\n\n/* ========================================\n   TABLE OVERRIDES\n   ======================================== */\n\n.scl--cms-pages-content-tableWrapper .scl--components-pagination-container {\n  margin-top: 10px;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-main tbody td:last-child {\n  align-items: center;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row.selected {\n  background: var(--scl--cms-pages-content-table-row-selected-bg) !important;\n}\n\n.scl--cms-pages-content-tableWrapper .scl--components-table-dynamicTable-row:hover {\n  background: var(--scl--cms-pages-content-table-row-hover-bg) !important;\n}\n\n/* ========================================\n   EMPTY STATE\n   ======================================== */\n\n.scl--cms-pages-content-emptyWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 80px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
